<template>
  <div class="panel-admin-body">
    <div class="d-flex title">
      Wizard
      <div class="ml-auto">
        <i v-show="this.$root.getShowMenuIcon() && this.$root.getShowHeaderMenu()" class="fa fa-window-minimize pl-1 pr-1" aria-hidden="true" @click="toggleHeaderMenu()"></i>
        <i v-show="this.$root.getShowMenuIcon() && !this.$root.getShowHeaderMenu()" class="fa fa-window-maximize pl-1 pr-1" aria-hidden="true" @click="toggleHeaderMenu()"></i>
      </div>
    </div>
    <saved-card-menu :entry-client-object="clientObject" :original-saved-cards="profileSavedCards" set-type="survey" view-type="menu"></saved-card-menu>
    <div class="chart-app">
      <chart-criteria-roadmap
        ref="chartCriteria"
        styles-mode
        :include-show-competitor-expectations="true"
        :include-show-pricing-power="true"
        :use-chart-type-card="true"
        display-type-label="Views"
        showUseTTMAsStartDate="true"
        :show-display-type="true"
        fixed-display-type="sales-wizard"
        :display-type-options-override="[{ name: 'Styles', value: 'sales-wizard' }]"
        :is-comparative="false"
        is-profile-page="true"
        :maximum-competitors="maximumCompetitors"
        :content-list="pageContent"
        :view-navigation-options="wizardViewOptions"
        :current-view="currentWizardView"
        :wizard-mode="true"
        :battlecard-criteria="battlecardCriteria"
        :battlecard-processing="battlecardProcessing"
        :battlecard-can-build="battlecardCanBuild"
        @select-view="selectWizardView"
        @individual-respondents="handleIndividualRespondents"
        @battlecard-criteria-changed="handleBattlecardCriteriaChanged"
        @battlecard-selection-changed="handleBattlecardSelectionChanged"
        @build-battlecards="buildBattlecards"
        @send-battlecards="sendBattlecards"
        @reset-client-chart="resetClientChart"
        @reset-sub-chart-criteria="resetSubChartCriteria"
        @prepare-battlecard-save="prepareBattlecardSave"
      />
      <div class="row no-gutters">
        <div class="col">
          <div id="chartDislayCard">
            <div id="performance_dashboard">
              <div id="chart-filters" class="row">
                <chart-criteria-results
                  v-show="!generatingChart && displayChartCriteriaResults"
                  ref="chartCriteriaResults"
                  :criteria-results-list="criteriaResultsList"
                  :criteria-results-company-list="criteriaResultsCompanyList"
                />
              </div>
              <chart-display-skeleton v-show="generatingChart" />
              <BySalesWizard
                v-show="isBySalesWizard && !generatingChart && currentWizardView === 'wizard-styles'"
                :chart-data="chartData"
                :content-list="pageContent"
                :file-download-name-suffix="survey.name"
                :selected-individual-respondents="selectedBattlecardRespondents"
                @set-sales-wizard-data="handleSalesWizardData"
              />
            </div>
          </div>
        </div>
      </div>
      <sales-wizard-recommendations
        v-show="currentWizardView === 'battlecard' && !generatingChart"
        ref="salesWizard"
        :input-needs-list="needsList"
        :is-explorer-page="false"
        :debug-mode="false"
        :entry-survey-code="surveyCode"
        :client-object="clientObject"
        :client-chart="clientChart"
        :auto-generate-verbatims="autoGenerateChart"
        :client-settings="clientSettings"
        :sales-wizard-data="salesWizardData"
        :external-battlecard-controls="true"
        :external-battlecard-criteria="battlecardCriteria"
        :external-selected-respondents="selectedBattlecardRespondents"
        :content-list="pageContent"
        :file-download-name-suffix="survey.name"
        :wizard-mode="isWizardUser"
        @run-completed="battlecardHasRun = true"
        @save-sales-wizard-criteria="handleSaveSalesWizardCriteria"
        @battlecard-selection-changed="handleBattlecardSelectionChanged"
      />
    </div>
    <vue-modal ref="save-chart-confirmation" name="save-chart-confirmation" :width="350" :height="200">
      <save-chart button-label="Save as Card" :chart-title="currentWizardView === 'battlecard' ? 'Battle Card' : chart.title" :initial-client-chart="clientChart" @save="updateClientCharts" @closeModal="closeModal('save-chart-confirmation')" />
    </vue-modal>
    <vue-modal ref="print-chart" name="print-chart" :width="350" :height="200">
      <chart-criteria-results
        ref="chartCriteriaResults"
        :criteria-results-list="criteriaResultsList"
        :criteria-results-company-list="criteriaResultsCompanyList"
      />
    </vue-modal>
    <roadmap-initiatives-modal ref="roadMapInitiativesForProfileTable" :modal-name="'road-map-initiatives-profile'" />
    <explore-navigation-modal ref="exploreNavigationModal" :modal-name="'explore-navigation-modal'" :modal-id="'explore-navigation-modal'" />
    <print-instant-report-modal
      ref="printInstantReportModal"
      :client-report-id="clientReportId"
      :existing-client-report="existingClientReport"
      :default-title="clientChart && clientChart.clientChartId > 0 && clientChart.name ? clientChart.name : instantReportDefaultTitle"
      :default-sub-title="instantReportDefaultSubTitle"
      :before-generate-report="copyContentForReport"
    />
  </div>
</template>

<script>
import ChartCompanyMixins from "../../mixins/ChartCompanyMixins.vue";
import ChartCriteriaRoadmap from "../../components/chart/ChartCriteriaRoadmap.vue";
import ChartDisplaySkeleton from "../../components/skeleton/ChartDisplaySkeleton.vue";
import SaveChart from "../../components/chart/SaveChart.vue";
import BySalesWizard from "./type/BySalesWizard.vue";
import SalesWizardRecommendations from "../../components/chart/SalesWizardRecommendations.vue";
import ChartCriteriaResults from "../../components/chart/ChartCriteriaResults.vue";
import RoadmapInitiativesModal from "../../modals/RoadmapInitiativesModal.vue";
import ExploreNavigationModal from "../../modals/ExploreNavigationModal.vue";
import PrintInstantReportModal from "../../modals/PrintInstantReportModal.vue";
import ChartService from "../../services/chart.service";
import ErrorService from "../../services/error.service";
import AdminService from "../../services/admin.service";
import ValueGroupMap from "../../services/chart/value.group.map.service";
import UserService from "../../services/user.service";

export default {
  name: "WizardStyles",
  mixins: [ChartCompanyMixins],
  components: {
    ChartCriteriaRoadmap,
    ChartDisplaySkeleton,
    SaveChart,
    BySalesWizard,
    SalesWizardRecommendations,
    ChartCriteriaResults,
    RoadmapInitiativesModal,
    ExploreNavigationModal,
    PrintInstantReportModal
  },
  props: {
    autoGenerateChart: { type: [Boolean, String], default: false },
    saveClientChartId: { type: Number, default: 0 }
  },
  data() {
    return {
      title: "Wizard",
      chartData: [],
      salesWizardCriteria: "",
      salesWizardData: {},
      isBySalesWizard: false,
      currentWizardView: "battlecard",
      selectedBattlecardRespondents: [],
      activeCardView: "",
      stylesHasRun: false,
      battlecardHasRun: false,
      battlecardCriteria: {
        includeValueGaps: "Y",
        includeExpectations: "Y",
        includePerformance: "Y",
        includeCompetitor: "Y",
        includeWillingnessToPay: "Y",
        includeVerbatims: "Y",
        numberOfRecommendations: 0,
        salesWizardAiTypeId: 0,
        briefEmailRecipients: ""
      },
      displayProfileStrengthLegend: false,
      selectedValueRoadMapId: 0,
      needsList: [],
      clientReportId: 0,
      instantReportDefaultTitle: "",
      instantReportDefaultSubTitle: "",
      existingClientReport: null
    };
  },
  computed: {
    disableSaveAsCardButton() {
      const hasRun = this.currentWizardView === "battlecard" ? this.battlecardHasRun : this.stylesHasRun;
      return this.isW5OUser || this.isInsiderUser || !hasRun || this.generatingChart || this.battlecardProcessing;
    },
    isWizardUser() {
      return UserService.isWizardUser();
    },
    profileSavedCards() {
      const battlecardChartType = ChartService.findChartTypeByName("battlecard");
      return this.clientChartsBySurvey.filter(card =>
        card.displayType == "sales-wizard" || Number(card.chartTypeId) === battlecardChartType.chartTypeId
      );
    },
    wizardViewOptions() {
      return [
        { name: "Battlecard", value: "battlecard" },
        { name: "Styles", value: "wizard-styles" }
      ];
    },
    // Add this back { name: "Scout", value: "scout" }
    showSalesWizard() {
      return this.isBySalesWizard;
    },
    maximumCompetitors() {
      return 5;
    },
    battlecardProcessing() {
      const recommendations = this.$refs.salesWizard;
      return recommendations != null && (
        recommendations.emailBriefsProcessing ||
        (recommendations.processInitiated && !recommendations.processingComplete)
      );
    },
    battlecardCanBuild() {
      if (this.selectedBattlecardRespondents.length === 0) return false;
      const recommendations = this.$refs.salesWizard;
      return recommendations == null || (
        !recommendations.deactivateGeneratedThemesButton &&
        !recommendations.oneTimeRunOnlyForInsiderUser &&
        !recommendations.noInputSelected
      );
    }
  },
  methods: {
    prepareWizardRun(view) {
      if (this.activeCardView && this.activeCardView !== view) {
        // Keep the object shared with SaveChart and the recommendation component.
        // Replacing it triggers the recommendation watcher, which resets inputs.
        Object.keys(this.clientChart).forEach(key => delete this.clientChart[key]);
        this.clientChart.clientChartId = 0;
        this.saveClientChartObject = { clientChartId: 0 };
        this.autoGenerateChartRun = false;
        this.salesWizardCriteria = "";
        this.stylesHasRun = false;
        this.battlecardHasRun = false;
        this.chartData = [];
        this.clientReportId = 0;
        this.existingClientReport = null;
        this.reportPagesList = [];
        this.instantReportDefaultSubTitle = "";
        const recommendations = this.$refs.salesWizard;
        if (recommendations) {
          recommendations.destroySalesWizardTables();
          recommendations.showResults = false;
          recommendations.topResults = [];
          recommendations.summary = "";
          recommendations.isSavedCard = false;
          recommendations.savedSurveyTakerAiTypeMap = {};
          recommendations.savedCardAutoProcessPending = false;
          recommendations.processInitiated = false;
          recommendations.processingComplete = false;
        }
      }
      this.activeCardView = view;
    },
    displayChart(clientId) {
      // displayMainChart validates the form before reaching this method.
      this.prepareWizardRun(this.currentWizardView);
      return ChartCompanyMixins.methods.displayChart.call(this, clientId);
    },
    selectWizardView(view) {
      if (view !== this.currentWizardView) this.prepareWizardRun(view);
      this.currentWizardView = view;
    },
    handleSalesWizardData(data) {
      this.salesWizardData = data;
    },
    handleIndividualRespondents(individualRespondents) {
      this.salesWizardData = { ...this.salesWizardData, individualRespondents };
    },
    handleBattlecardCriteriaChanged(criteria) {
      this.battlecardCriteria = { ...criteria };
    },
    handleBattlecardSelectionChanged(respondents) {
      this.selectedBattlecardRespondents = Array.isArray(respondents) ? respondents : [];
    },
    setClientChart() {
      const chartCriteria = this.$refs.chartCriteria;
      const battlecardChartType = ChartService.findChartTypeByName("battlecard");
      const criteriaParams = this.getChartCriteriaParams(this.clientChart, chartCriteria);
      const existingParams = new URLSearchParams(this.clientChart.criteria || "");
      criteriaParams.forEach((value, key) => existingParams.set(key, value));

      this.clientChart.chartTypeId = battlecardChartType.chartTypeId;
      this.clientChart.clientId = this.clientId;
      this.clientChart.criteria = existingParams.toString();
      if (typeof this.clientChart.clientTimePeriodId == "undefined" && typeof chartCriteria.$data.period != "undefined") {
        this.clientChart.clientTimePeriodId = chartCriteria.$data.period;
      }
      this.clientChart.displayType = battlecardChartType.shortName;

      if (typeof this.saveClientChartObject.name == "undefined" || this.saveClientChartObject.name == "") {
        const chartTitle = ChartService.createDefaultSaveChartName(this.chart.title, this.clientChart.displayType);
        this.clientChart.name = chartTitle + " " + chartCriteria.getPeriodName(this.clientChart.clientTimePeriodId);
      }
    },
    prepareBattlecardSave() {
      const battlecardChartType = ChartService.findChartTypeByName("battlecard");
      this.clientChart.chartTypeId = battlecardChartType.chartTypeId;
      this.clientChart.displayType = battlecardChartType.shortName;
    },
    buildBattlecards() {
      if (this.$refs.salesWizard != null) {
        if (!this.$refs.salesWizard.validateSalesWizardRecommendationCriteria()) return;
        this.prepareWizardRun("battlecard");
        this.setClientChart();
        this.$refs.salesWizard.generateSalesWizardRecommendations();
      }
    },
    sendBattlecards() {
      if (this.$refs.salesWizard != null) {
        if (!this.$refs.salesWizard.validateBriefEmailRecipients() ||
            !this.$refs.salesWizard.validateSalesWizardRecommendationCriteria()) return;
        this.prepareWizardRun("battlecard");
        this.setClientChart();
        this.$refs.salesWizard.emailBriefs();
      }
    },
    resetSubChartCriteria() {
      if (this.currentWizardView === "battlecard") this.battlecardHasRun = false;
      else this.stylesHasRun = false;
      if (this.currentWizardView === "battlecard" && this.$refs.salesWizard != null) this.$refs.salesWizard.resetValues();
      this.clientReportId = 0;
      this.existingClientReport = null;
    },
    handleSaveSalesWizardCriteria(params) {
      const existingParams = new URLSearchParams(this.clientChart.criteria);
      if (params && Array.isArray(params.deleteParams)) {
        params.deleteParams.forEach(param => existingParams.delete(param));
        this.salesWizardCriteria = "";
        this.clientChart.criteria = existingParams.toString();
        return;
      }
      this.salesWizardCriteria = params.toString();
      for (const [key, value] of new URLSearchParams(this.salesWizardCriteria).entries()) {
        existingParams.set(key, value);
      }

      const selectedRespondentIds = this.selectedBattlecardRespondents
        .map(respondent => respondent.surveyTakerId)
        .filter(value => value != null && value !== "");
      if (selectedRespondentIds.length > 0) {
        existingParams.set("selected_respondents", JSON.stringify(selectedRespondentIds));
      } else {
        existingParams.delete("selected_respondents");
      }

      this.clientChart.criteria = existingParams.toString();
    },
    setInstantReportDefaultTitle() {
      this.instantReportDefaultTitle = this.clientObject && typeof this.clientObject.name == "string"
        ? `W Report - ${this.clientObject.name}`
        : "";
    },
    async copyContentForReport(clientReportId) {
      this.clientReportId = clientReportId;
    },
    closeModal(name) {
      if (this.$refs[name] != null) this.$refs[name].visible = false;
    },
    displayChartCallback(response) {
      try {
        this.$root.processServerResponse();
        this.generatingChart = false;
        this.chartData = response.data;
        this.isBySalesWizard = this.$refs.chartCriteria.$data.displayType == "sales-wizard";
        this.displayProfileStrengthLegend = false;
        this.instantReportDefaultSubTitle = this.$refs.chartCriteria.getPeriodName(this.$refs.chartCriteria.$data.period);
        this.setInstantReportDefaultTitle();
        this.stylesHasRun = true;
      } catch (error) {
        ErrorService.processException("WizardStyles.displayChartCallback", error, "chart", this);
      }
    },
    goToExploreForProfileTable(needType, needNumber) {
      this.$refs.exploreNavigationModal.$data.needType = needType;
      this.$refs.exploreNavigationModal.$data.needNumber = needNumber;
      this.$refs.exploreNavigationModal.$data.clientChartId = this.clientChart.clientChartId;
      this.$modal.show("explore-navigation-modal");
    },
    async displayInitiativesForProfileTable(element) {
      const needName = element.name;
      const moatName = element.moatName;
      const needNumber = element.needNumber;
      const needType = element.needType;
      let initiative = "";
      let description = "";
      await ValueGroupMap.getValueRoadMapInitiative(this.survey.surveyCode, needNumber, needType, this.selectedValueRoadMapId, response => {
        if (response.data.statusCode == 200) {
          initiative = response.data.data.initiative;
          description = response.data.data.description;
          this.selectedValueRoadMapId = response.data.data.valueRoadMapId;
        } else {
          AdminService.displayErrorMessage({ text: response.data.message });
        }
      }, this);
      const modal = this.$refs.roadMapInitiativesForProfileTable;
      modal.$data.selectedInitiative = { initiative, description };
      modal.$data.title = needName;
      modal.$data.moatName = moatName;
      modal.$data.needName = needName;
      modal.$data.needNumber = needNumber;
      modal.$data.needType = needType;
      modal.$data.valueRoadMapId = this.selectedValueRoadMapId;
      modal.$data.sequenceNumber = element.sequenceNumber;
      modal.$data.initiatives = JSON.parse(JSON.stringify(element.initiativeSuggestions));
      modal.$data.moatInitiatives = JSON.parse(JSON.stringify(element.moatInitiatives));
      modal.$data.moatDescription = JSON.parse(JSON.stringify(element.moatDescription || { description: "", attributes: "{}" }));
      modal.$data.displayInitiatives = true;
      modal.$data.showCustomInitiative = true;
      modal.$data.addOrSaveInitiative = "Save";
      modal.$data.saveEnabled = true;
      modal.loadData();
      this.$modal.show("road-map-initiatives-profile");
    }
  },
  watch: {
    saveClientChartId(id) {
      const savedCard = this.clientObject.clientCharts.find(card => card.clientChartId == id);
      if (!savedCard) return;
      this.currentWizardView = Number(savedCard.chartTypeId) === ChartService.findChartTypeByName("battlecard").chartTypeId
        ? "battlecard"
        : "wizard-styles";
      this.activeCardView = this.currentWizardView;
    },
    surveyCode() {
      this.activeCardView = "";
      this.stylesHasRun = false;
      this.battlecardHasRun = false;
    }
  },
  created() {
    this.chart = ChartService.getChartAttributes("Profile");
    if (Number(this.saveClientChartId) > 0 || this.autoGenerateChart === true || this.autoGenerateChart === "true") {
      const savedCard = this.clientObject.clientCharts.find(card => card.clientChartId == this.saveClientChartId);
      this.currentWizardView = savedCard && Number(savedCard.chartTypeId) === ChartService.findChartTypeByName("battlecard").chartTypeId
        ? "battlecard"
        : "wizard-styles";
      this.activeCardView = this.currentWizardView;
    }
  }
};
</script>